import { api } from "@/lib/api/client";
import type { TemplateListResponse, TemplateOneResponse, ThemeTemplate } from "./types";

// Prefix /api/settings (ver app.ts:650).
export const themeApi = {
  list: async (): Promise<ThemeTemplate[]> => {
    const { data } = await api.get<TemplateListResponse>("/api/settings/theme/templates");
    return data.data ?? [];
  },
  snapshot: async (name: string, activate = false): Promise<ThemeTemplate> => {
    const { data } = await api.post<TemplateOneResponse>(
      "/api/settings/theme/templates/snapshot",
      { name, activate },
    );
    return data.data;
  },
  update: async (id: number, body: { name?: string; tokens?: Record<string, any> }): Promise<ThemeTemplate> => {
    const { data } = await api.put<TemplateOneResponse>(
      `/api/settings/theme/templates/${id}`,
      body,
    );
    return data.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/settings/theme/templates/${id}`);
  },
  activate: async (id: number): Promise<ThemeTemplate> => {
    const { data } = await api.post<TemplateOneResponse>(
      `/api/settings/theme/templates/${id}/activate`,
    );
    return data.data;
  },
  publish: async (id: number): Promise<ThemeTemplate> => {
    const { data } = await api.post<TemplateOneResponse>(
      `/api/settings/theme/templates/${id}/publish`,
    );
    return data.data;
  },
  unpublish: async (id: number): Promise<ThemeTemplate> => {
    const { data } = await api.post<TemplateOneResponse>(
      `/api/settings/theme/templates/${id}/unpublish`,
    );
    return data.data;
  },
};
